type Next = null | (() => {});
export function raf(cb: (...args: any[]) => any) {
  let next: Next = null;
  let stop = true;
  function run() {
    requestAnimationFrame(() => {
      if (!next) {
        stop = true;
        return;
      }
      stop = false;
      const _next = next;
      next = null;
      try {
        _next();
      } catch (e) {
        console.error(e);
      } finally {
        run();
      }
    });
  }
  return function(...args: any[]) {
    next = () => cb.apply(null, args);
    stop && run();
  };
}
